<template>
    <div class="table" v-bind:class="classes">
        <slot />
    </div>
</template>

<script>
    export default {
        name: 'app-table',
        props: {
            responsive: {
                type: String
            }
        },
        computed: {
            classes() {
                let classes = {};
                if(typeof this.responsive != 'undefined') {
                    classes['table--responsive  table--responsive--'+this.responsive] = true;
                }
                return classes;
            }
        }
    }
</script>

<style lang="scss">
    .table {
        @apply .w-full .border .border-grey-lighter;
        display: table;
    }
</style>


// WEBPACK FOOTER //
// src/components/table/Wrapper.vue